import { RoutePath } from "@mirage/webapp/routeTypes";

export const getTeamProfilePageHref = (teamId: string): string => {
  if (!teamId) {
    return "";
  }
  return RoutePath.TEAM_PROFILE.replace(":id", teamId);
};
